import AirbrakeClient from 'airbrake-js';
import Vue from "vue";

export default ({ store, app: { router, context } }, inject) => {

	if(!process.client)
		return;



  if(process.env.VUE_APP_SEND_FRONT_END_AIRBRAKE_ALERTS == 'true'){

      var airbrake = new AirbrakeClient({
        projectId: process.env.VUE_APP_WEBSHOP_AIRBRAKE_PROJECT_ID,
        projectKey: process.env.VUE_APP_WEBSHOP_AIRBRAKE_PROJECT_KEY
      });

      airbrake.addFilter(function(notice) {
      //    Object Not Found Matching Id
        if(notice.errors[0].message.includes('Object Not Found Matching')) {
          return null;
        }
        return notice;
      });


      // Catch Vue Errors
      Vue.config.errorHandler = (err, vm, info) => {
              airbrake.notify({
                  error: err,
                  params: {info: info}
              });
      }

      // Catch Vue Warnings
      Vue.config.warnHandler = (msg, vm, trace) => {
              airbrake.notify({
                  error: msg,
                  params: {trace: trace}
              });
      }

      // Catch Javascript errors
      window.onerror = (msg, src, linenum, colnum, error) => { 
              airbrake.notify({
                  error: error,
                  params: {
                      msg: msg,
                      src: src,
                      linenum: linenum,
                      colnum: colnum
                  }
              });
      }

  }
        
}           
